import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { ContractCumulative } from './contract-cumulative.model';
import { CalcType, IServiceItem, ITask, IUserGroup } from '../../lookups';
import { Users } from './users.model';
import { CostCenter } from '../CostCenter';
import { SessionDates } from '../SessionDates';

export const getSessionDates = createAction(
  '[ContractCumulative/API] GET Session Dates',
);
export const loadSessionDates = createAction(
  '[ContractCumulative/API] Load Session Dates',
  props<{ sessionDates: SessionDates[] }>()
);

export const getContractCumulatives = createAction(
  '[ContractCumulative/API] GET ContractCumulatives',
);

export const postContractCumulatives = createAction(
  '[ContractCumulative/API] POST ContractCumulatives',
  props<{ DirectOrIndirect: string, Todayonly: boolean, Asofdate: Date, Tasks: ITask[], ServiceItems: IServiceItem[], DirectReports: Users[], Txntype: string, CostCenters: IUserGroup[] }>()
);

export const uploadCumulatives = createAction(
    '[ContractCumulative/API] POST UploadCumulatives',
    props<{ JsonString: string }>()
  );

export const putContractCumulatives = createAction(
  '[ContractCumulative/API] PUT ContractCumulatives',
  props<{ contractcums: Array<ContractCumulative>}>()
);

export const removeContractCum = createAction(
  '[ContractCumulative/API] Remove ContractCumulative',
  props<{ ids: Array<string> }>()
);

export const getTxnTypes = createAction(
  '[ContractCumulative/API] Get Txn Types'
);
export const loadTxnTypes = createAction(
  '[ContractCumulative/API] Load Txn Types',
  props<{ txnTypes: CalcType[] }>()
);

export const getUsers = createAction(
  '[ContractCumulative/API] Get Users',
  props<{ UserFilterID: number, ShowInactive: boolean }>()
);
export const loadUsers = createAction(
  '[ContractCumulative/API] Load Users',
  props<{ users: Users[] }>()
);

export const loadContractCumulatives = createAction(
  '[ContractCumulative/API] Load ContractCumulatives',
  props<{ contractCumulatives: ContractCumulative[] }>()
);

export const addContractCumulative = createAction(
  '[ContractCumulative/API] Add ContractCumulative',
  props<{ contractCumulative: ContractCumulative }>()
);

export const upsertContractCumulative = createAction(
  '[ContractCumulative/API] Upsert ContractCumulative',
  props<{ contractCumulative: ContractCumulative }>()
);

export const addContractCumulatives = createAction(
  '[ContractCumulative/API] Add ContractCumulatives',
  props<{ contractCumulatives: ContractCumulative[] }>()
);

export const upsertContractCumulatives = createAction(
  '[ContractCumulative/API] Upsert ContractCumulatives',
  props<{ contractCumulatives: ContractCumulative[] }>()
);

export const updateContractCumulative = createAction(
  '[ContractCumulative/API] Update ContractCumulative',
  props<{ contractCumulative: Update<ContractCumulative> }>()
);

export const updateContractCumulatives = createAction(
  '[ContractCumulative/API] Update ContractCumulatives',
  props<{ contractCumulatives: Update<ContractCumulative>[] }>()
);

export const deleteContractCumulative = createAction(
  '[ContractCumulative/API] Delete ContractCumulative',
  props<{ id: string }>()
);

export const deleteContractCumulatives = createAction(
  '[ContractCumulative/API] Delete ContractCumulatives',
  props<{ ids: string[] }>()
);

export const clearContractCumulatives = createAction(
  '[ContractCumulative/API] Clear ContractCumulatives'
);

export const updateContractCumulativeSuccess = createAction(
  '[ContractCumulative/API] Update ContractCumulatives Success Event',
  props<{ contractCumulative: Partial<ContractCumulative> }>()
);
